import {
  type AppController,
  type SerializedCompStructure,
} from '@wix/document-services-types'

export function assertAppControllerData(
  data: NonNullable<SerializedCompStructure['data']>,
): asserts data is AppController {
  if (data.type !== 'AppController') {
    throw new Error('Not an app-controller data.')
  }
}
